import { render } from "./ExpiredSession.vue?vue&type=template&id=0a3cc2ce&scoped=true&ts=true"
import script from "./ExpiredSession.vue?vue&type=script&lang=ts"
export * from "./ExpiredSession.vue?vue&type=script&lang=ts"

import "./ExpiredSession.vue?vue&type=style&index=0&id=0a3cc2ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3cc2ce"]])

export default __exports__